(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fitment-scanner"] && !Shopify.designMode) return;
  try {
    // Measure My Face without a product (owner, 2026-10-17). Pages other than product pages carry the stand-alone scanner
  // inside <template data-sa-mmf-template> (layout/theme.liquid), so nothing of it loads until a Measure My Face link
  // is used: the first #measure-my-face link, or arriving with #measure-my-face / #face-fit-start / #face-fit-saved,
  // puts it on the page, and the scanner's own code below takes over. A page with a scanner already (a mask page, the
  // Measure My Face page) never uses the template.
  (() => {
    const template = () => document.querySelector('template[data-sa-mmf-template]');
    function mount() {
      const existing = document.querySelector('face-fit-scanner');
      if (existing) return existing;
      const source = template();
      if (!source) return null;
      // importNode builds the nodes in this page's document. iPhone Safari set up a <video> cloned out of the template
      // with the template's inert document, so the camera ran but the preview stayed black (owner, 2026-10-17); the
      // preview element is also recreated here, muted and inline, before the scanner starts.
      const fragment = document.importNode(source.content, true);
      fragment.querySelectorAll('video[data-video]').forEach((old) => {
        const video = document.createElement('video');
        Array.from(old.attributes).forEach((attribute) => video.setAttribute(attribute.name, attribute.value));
        video.muted = true;
        video.defaultMuted = true;
        video.playsInline = true;
        video.autoplay = true;
        old.replaceWith(video);
      });
      document.body.append(fragment);
      source.remove();
      return document.querySelector('face-fit-scanner[data-standalone="true"]');
    }
    if (['#measure-my-face', '#face-fit-start', '#face-fit-saved'].includes(window.location.hash)) mount();
    document.addEventListener('click', (event) => {
      if (window.SA_MEASURE_LINK_ROOT || document.querySelector('face-fit-scanner')) return;
      const link = event.target instanceof Element ? event.target.closest('a[href*="#measure-my-face"]') : null;
      if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (link.target && link.target !== '_self') return;
      const root = mount();
      if (!root) return; // No template here: the link opens the Measure My Face page instead.
      event.preventDefault();
      const open = () => root.querySelector('[data-face-fit-open]')?.click();
      if (root.dataset.initialized === 'true') open();
      else root.addEventListener('space-armory:scanner-ready', open, {once: true});
    }, true);
  })();

  // The stand-alone result: Save My Size keeps the size on this device (assets/face-fit-memory.js, as an applied camera
  // result does on a mask page) and, for a signed-in visitor, in the account too (the face-fit-profile element's own
  // save). A guest gets a sign-in link; after signing in, the account flow brings the result back and saves it.
  (() => {
    const scanner = (node) => node instanceof Element ? node.closest('face-fit-scanner[data-standalone="true"]') : null;
    function show(root, record) {
      const rules = window.SpaceArmoryFitRules;
      const size = rules.sizeFor(record.cm);
      const box = root.querySelector('[data-mmf-saved]');
      box.querySelector('[data-mmf-saved-title]').textContent = box.dataset.titleTemplate.replace('__SIZE__', size);
      box.querySelector('[data-mmf-saved-sub]').textContent = box.dataset.subTemplate.replace('__SIZE__', size);
      root.dataset.mmfSaved = 'true';
      root.querySelector('[data-mmf-saved-title]').focus({preventScroll: true});
    }
    function account(root, state) {
      const guest = root.querySelector('[data-mmf-guest]');
      const saved = root.querySelector('[data-mmf-account]');
      const status = root.querySelector('[data-mmf-account-status]');
      guest.hidden = state !== 'guest';
      saved.hidden = state !== 'saved';
      status.textContent = typeof state === 'object' ? state.text : '';
    }
    async function save(root, restored) {
      const record = root.saMmfRecord;
      const rules = window.SpaceArmoryFitRules;
      if (!record || !rules?.valid?.(record)) return;
      window.SpaceArmoryFitMemory?.write({cm: record.cm, method: 'camera', measuredAt: record.measuredAt}, 'measure-my-face');
      show(root, record);
      document.dispatchEvent(new CustomEvent('space-armory:size-saved', {detail: {measurement: record}}));
      const profile = root.querySelector('face-fit-profile');
      const signedIn = !!window.SpaceArmoryFitAccount?.state?.customer;
      if (!signedIn || !profile) { account(root, 'guest'); return; }
      account(root, '');
      // After a sign-in round trip the profile element saves the restored result itself.
      if (!restored) await profile.save?.();
      else await new Promise((resolve) => window.setTimeout(resolve, 1500));
      const text = profile.querySelector('[data-profile-status]')?.textContent || '';
      account(root, profile.saved ? 'saved' : (text ? {text} : ''));
    }
    document.addEventListener('space-armory:scan-complete', (event) => {
      const root = scanner(event.target);
      if (!root) return;
      root.saMmfRecord = event.detail?.measurement || null;
      delete root.dataset.mmfSaved;
      if (event.detail?.restored) window.requestAnimationFrame(() => save(root, true));
    }, true);
    document.addEventListener('space-armory:sizing-guide-opened', (event) => {
      const root = scanner(event.target);
      if (root) delete root.dataset.mmfSaved;
    }, true);
    document.addEventListener('click', (event) => {
      const target = event.target instanceof Element ? event.target.closest('[data-mmf-save]') : null;
      const root = scanner(target);
      if (root) save(root, false);
    });
    // Sign in: the link is the slot of a <shopify-account>, whose own click opens Shopify's sign-in sheet. Before it
    // does, the result is kept the way face-fit-account.js keeps it (its pending key), so after signing in the page
    // brings the result back (#face-fit-saved) and the account element saves it.
    document.addEventListener('click', (event) => {
      const link = event.target instanceof Element ? event.target.closest('[data-mmf-sign-in]') : null;
      const root = scanner(link);
      if (!root || !root.saMmfRecord) return;
      const back = window.location.pathname + window.location.search + '#face-fit-saved';
      try {
        sessionStorage.setItem('sa_face_fit_login_pending_v1', JSON.stringify({measurement: root.saMmfRecord, path: window.location.pathname, search: window.location.search, expires: Date.now() + 20 * 60 * 1000}));
      } catch (error) {}
      link.closest('shopify-account')?.setAttribute('sign-in-url', '/customer_authentication/login?return_to=' + encodeURIComponent(back));
    }, true);
  })();

  // Brand language (owner 2026-10-15): look and motion of the measuring screens only. It reads what the scanner
  // already produces (the progress value, the active stage, the space-armory:scan-complete result) and never changes
  // a measurement, the accepted range or any text.
  (() => {
    const ns = 'http://www.w3.org/2000/svg';
    const reduce = () => window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const chart = {cm: {S: ['12', '13'], M: ['13', '14'], L: ['14', '15'], XL: ['15', '16'], XXL: ['16', '17']},
      in: {S: ['4.7', '5.1'], M: ['5.1', '5.5'], L: ['5.5', '5.9'], XL: ['5.9', '6.3'], XXL: ['6.3', '6.7']}};
    const decimal = (text) => window.SA_I18N ? String(text).replace(/(\d)\.(\d)/g, '$1,$2') : String(text);
    function brand(root) {
      if (root.dataset.saBrand === 'true') return;
      root.dataset.saBrand = 'true';
      const progress = root.querySelector('[data-progress]');
      const ring = root.querySelector('[data-ring]');
      const ticks = [];
      if (ring) {
        for (let i = 0; i < 60; i += 1) {
          const a = (i / 60) * Math.PI * 2 - Math.PI / 2;
          const line = document.createElementNS(ns, 'line');
          line.setAttribute('x1', (200 + 66 * Math.cos(a)).toFixed(1)); line.setAttribute('y1', (150 + 89 * Math.sin(a)).toFixed(1));
          line.setAttribute('x2', (200 + 75 * Math.cos(a)).toFixed(1)); line.setAttribute('y2', (150 + 101 * Math.sin(a)).toFixed(1));
          ring.append(line); ticks.push(line);
        }
      }
      let lit = 0, frame = 0;
      const paint = (count) => {
        if (count === lit) return;
        ticks.forEach((tick, index) => tick.classList.toggle('is-on', index < count));
        lit = count;
      };
      const follow = () => {
        frame = 0;
        if (root.dataset.activeStage !== 'measure' || !progress) return;
        paint(Math.round(Math.min(1, progress.value / (progress.max || 60)) * ticks.length));
        frame = requestAnimationFrame(follow);
      };
      new MutationObserver(() => {
        if (root.dataset.activeStage === 'measure') { if (!frame) frame = requestAnimationFrame(follow); }
        else if (root.dataset.activeStage !== 'result') paint(0);
      }).observe(root, {attributes: true, attributeFilter: ['data-active-stage']});
      root.addEventListener('space-armory:scan-complete', (event) => {
        const cm = event.detail && event.detail.measurement && event.detail.measurement.cm;
        const rules = window.SpaceArmoryFitRules;
        if (typeof cm !== 'number' || !rules) return;
        // After the scanner has written its own texts for this result.
        requestAnimationFrame(() => decorate(cm, rules.display(cm)));
      });
      function decorate(cm, shown) {
        const size = shown.size;
        const plate = root.querySelector('[data-recommended]');
        if (plate && !plate.hidden) {
          plate.querySelector('.face-fit__plate-ticks')?.remove();
          plate.insertAdjacentHTML('beforeend', '<span class="face-fit__plate-ticks" aria-hidden="true"><i></i><i></i><i></i><i></i></span>');
        }
        const range = root.querySelector('[data-sa-range]');
        const unit = root.dataset.sizeUnit === 'in' ? 'in' : 'cm';
        if (range && chart.cm[size]) {
          const cells = range.querySelectorAll('.face-fit__range-bar span');
          cells.forEach((cell) => cell.classList.toggle('is-hit', cell.textContent === size));
          range.querySelector('.face-fit__range-mark').style.left = Math.max(1, Math.min(99, (Number(shown.cm) - 12) / 5 * 100)) + '%';
          range.querySelector('[data-sa-range-label]').textContent = decimal(size + ' · ' + chart[unit][size][0] + '–' + chart[unit][size][1] + ' ' + unit);
          range.hidden = false;
        }
        const measurement = root.querySelector('[data-measurement]');
        const final = measurement && measurement.textContent;
        const match = final && final.match(/(\d+)([.,])(\d+)/);
        if (!match || reduce()) return;
        const places = match[3].length;
        const to = Number(match[1] + '.' + match[3]);
        const from = unit === 'in' ? 12 / 2.54 : 12;
        let start = 0;
        const token = String(performance.now());
        measurement.dataset.saCount = token;
        const step = (now) => {
          if (measurement.dataset.saCount !== token || measurement.hidden) return;
          if (!start) start = now + 500;
          const t = Math.max(0, Math.min(1, (now - start) / 700));
          const value = from + (to - from) * (1 - Math.pow(1 - t, 3));
          measurement.firstChild && (measurement.firstChild.nodeValue = final.replace(match[0], value.toFixed(places).replace('.', match[2])));
          if (t < 1) requestAnimationFrame(step); else measurement.firstChild.nodeValue = final;
        };
        requestAnimationFrame(step);
      }
    }
    document.addEventListener('space-armory:scanner-ready', (event) => { if (event.target.matches && event.target.matches('face-fit-scanner')) brand(event.target); }, true);
    document.querySelectorAll('face-fit-scanner[data-initialized="true"]').forEach(brand);
  })();

  (() => {
    function initializeScanner(root) {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const lifecycle = new AbortController();
    function listen(target, type, handler, options = {}) {
      target.addEventListener(type, handler, {...(typeof options === 'boolean' ? {capture: options} : options), signal: lifecycle.signal});
    }
    const dialog = root.querySelector('dialog');
    const opener = root.querySelector('[data-face-fit-open]');
    const video = root.querySelector('[data-video]');
    const progress = root.querySelector('[data-progress]');
    const scanStatus = root.querySelector('[data-scan-status]');
    const scanHeading = root.querySelector('[data-scan-heading]');
    const stageSteps = Array.from(root.querySelectorAll('[data-stage-step]'));
    const resultHeading = root.querySelector('[data-result-heading]');
    const resultStatus = root.querySelector('[data-result-status]');
    const manualOnly = root.querySelector('[data-manual-only]');
    const recommended = root.querySelector('[data-recommended]');
    const measurement = root.querySelector('[data-measurement]');
    const applyButton = root.querySelector('[data-apply]');
    const addButton = root.querySelector('[data-add]');
    const errorMessage = root.querySelector('[data-error-message]');
    const guideArts = Array.from(root.querySelectorAll('[data-guide-art]'));
    const guideCount = root.querySelector('[data-guide-count]');
    const guidePanels = Array.from(root.querySelectorAll('[data-guide-panel]'));
    const guideDots = Array.from(root.querySelectorAll('[data-guide-dot]'));
    const guide = root.querySelector('[data-guide]');
    const guidePrevious = root.querySelector('[data-guide-prev]');
    const guideForward = root.querySelector('[data-guide-forward]');
    const guideNext = root.querySelector('[data-guide-next]');
    const guideSkip = root.querySelector('[data-guide-skip]');
    const someoneElse = root.querySelector('[data-someone-else]');
    const startButton = root.querySelector('[data-start]');
    const resultMotion = root.querySelector('[data-result-motion]');
    const targetSamples = 60;
    const frameIntervalMs = 0;
    const referenceIrisDiameterCm = 1.17;
    const maskCurveFactor = 1.28;
    const warmupTarget = 30;
    const measurementStorageKey = 'sa_face_fit_measurement_v1';
    const measurementSourceStorageKey = 'sa_face_fit_product_v1';
    const measurementDeviceStorageKey = 'sa_face_fit_device_v1';
    const measurementStatsStorageKey = 'sa_face_fit_stats_v1';
    const attemptSessionKey = 'sa_face_fit_attempts_v1:' + (root.dataset.productId || root.dataset.productHandle);
    const attemptSessions = window.SpaceArmoryFitAttemptSessions ||= new Map();
    let scanAttempts = {schema:1, attempts:0, retries:0, failed:0};
    let attemptRunning = false;
    const legacyMeasurementStorageKey = '_sa_sinsi_olcum';
    const legacySourceStorageKey = '_sa_sinsi_kaynak';
    const measurementPropertyName = '_Face Fit Measurement';
    const scanSourcePropertyName = '_Face Fit Source';
    const scanActionPropertyName = '_Face Fit Action';
    const scanDevicePropertyName = '_Face Fit Device';
    const measuredPropertyName = 'Measured Size';
    // Hidden beside it: the full width in both units, "14.4 cm / 5.67 in - L" (face-fit-rules.js text()).
    const widthPropertyName = '_Face Fit Width';
    // Hidden beside it: both widths of this scan and which one the shopper saw (face-fit-iris.js), for the comparison.
    const comparePropertyName = '_Face Fit Compare';
    const compareStorageKey = 'sa_face_fit_compare_v1';
    let activeCompareText = '';
    let irisFrames = [];
    let irisCanvas = null;
    let irisContext = null;
    const engineVersion = 'face-fit-engine/1.0.0';
    const sizeRuleVersion = 'size-rules/1.0.0';
    const modelVersion = 'model/64184e229b26';
    const dataSchemaVersion = 'schema/1';
    const sourceVersion = [engineVersion, sizeRuleVersion, modelVersion, dataSchemaVersion].join(' | ');
    let stream = null;
    let worker = null;
    let mainThreadLandmarker = null;
    let inferenceMode = 'worker';
    let engineGeneration = 0;
    let enginePromise = null;
    let cancelEnginePreparation = null;
    // Closing the window stops the camera at once but keeps a loaded engine this long, so Measure Again on the same page
    // starts without rebuilding it (owner, 16 Oct 2026). Leaving the page releases it at once.
    const engineKeepAfterCloseMs = 5 * 60 * 1000;
    let engineReleaseTimer = 0;
    let mainThreadWarmupFrames = 0;
    let mainThreadFrameCounter = 0;
    let mainThreadIsDark = false;
    let lightCanvas = null;
    let lightContext = null;
    let frameCallback = 0;
    let framePending = false;
    let lastFrameAt = 0;
    let samples = [];
    // Owner OK, 18 Oct (#5): a scan broken for longer than this starts counting again, and a full count that is not
    // steady keeps its newest 60 frames for up to another 60 before giving up. stable(), its spread and every constant
    // stay as they are.
    const sampleGapMs = 1500;
    let lastSampleAt = 0;
    let unsteadyFrames = 0;
    let glareShown = false;
    let glareOn = false;
    let steadyToday = null;
    let generation = 0;
    let sessionStarting = false;
    let finalizing = false;
    let scanTimeout = 0;
    let workerReadyTimer = 0;
    let cancelWorkerInit = null;
    let cancelVideoMetadataWait = null;
    let activeSize = null;
    let activeVariantId = null;
    let activeMeasurementText = '';
    let activeMeasurementDevice = null;
    let activeMeasurementStats = null;
    // The shown result as a measurement record; kept for every mask page only when the visitor applies it.
    let activeRecord = null;
    let variantActionBusy = false;
    // Error screen order (owner 18 Oct): failed scans in a row on this page (a result resets it), how often each camera
    // hint showed during the current scan, and when the camera was last asked for (a refusal within 400 ms had no prompt).
    let errorStreak = 0;
    let statusTally = {};
    let cameraRequestedAt = 0;
    let permissionFailures = 0;
    let previousBodyOverflow = '';
    let bodyScrollLocked = false;
    let focusAfterClose = true;
    let guideStep = 0;
    let guideActionAt = -Infinity;
    let guidePointer = null;
    let guideTransitions = [];
    let successHapticPlayed = false;
    let handoffUrl = '';
    let handoffModules = null;
    const reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const saveData = !!(navigator.connection && navigator.connection.saveData);
    const allowMotionVideo = !reducedMotion && !saveData;

    function hydrateMotionPoster(videoElement) {
      if (!videoElement) return;
      if (!videoElement.poster && videoElement.dataset.poster) videoElement.poster = videoElement.dataset.poster;
    }

    function hydrateMotion(videoElement) {
      if (!videoElement) return;
      hydrateMotionPoster(videoElement);
      if (!allowMotionVideo || videoElement.dataset.hydrated === 'true') return;
      const source = videoElement.querySelector('source[data-src]');
      if (!source) return;
      videoElement.preload = 'auto';
      source.src = source.dataset.src;
      videoElement.dataset.hydrated = 'true';
      videoElement.load();
    }

    // The preparation drawings are inline SVG drawn by CSS (.is-playing); nothing to download or pause.
    function stopGuideArt() {
      cancelGuideTransition();
      guideArts.forEach((item) => item.classList.remove('is-playing'));
    }

    function cancelGuideTransition() {
      guideTransitions.forEach((animation) => { animation.onfinish = null; animation.cancel(); });
      guideTransitions = [];
      guideArts.forEach((item, index) => { item.hidden = index !== guideStep; });
      guidePanels.forEach((item, index) => { item.hidden = index !== guideStep; });
    }

    function animateGuideChange(previousStep, direction) {
      // Both slides share the same fixed stage and text row: movement never changes layout.
      for (const items of [guideArts, guidePanels]) {
        const outgoing = items[previousStep];
        const incoming = items[guideStep];
        if (!outgoing || !incoming || typeof incoming.animate !== 'function') continue;
        outgoing.hidden = false;
        const out = outgoing.animate([
          {opacity: 1, transform: 'translateX(0)'},
          {opacity: 0, transform: 'translateX(' + (-10 * direction) + 'px)'}
        ], {duration: 220, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'both'});
        const enter = incoming.animate([
          {opacity: 0, transform: 'translateX(' + (14 * direction) + 'px)'},
          {opacity: 1, transform: 'translateX(0)'}
        ], {duration: 320, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'both'});
        out.onfinish = () => { outgoing.hidden = true; out.cancel(); };
        enter.onfinish = () => { enter.cancel(); };
        guideTransitions.push(out, enter);
      }
    }

    function setGuideStep(nextStep, animate = true) {
      if (!guidePanels.length) return;
      const previousStep = guideStep;
      cancelGuideTransition();
      guideStep = Math.max(0, Math.min(Number(nextStep) || 0, guidePanels.length - 1));
      guidePanels.forEach((panel, index) => {
        panel.hidden = index !== guideStep;
        panel.setAttribute('aria-hidden', String(index !== guideStep));
      });
      guideDots.forEach((dot, index) => {
        if (index === guideStep) dot.setAttribute('aria-current', 'step');
        else dot.removeAttribute('aria-current');
        // The "Step 1/4" plate fills one box per step reached.
        dot.classList.toggle('is-done', index <= guideStep);
      });
      if (guideCount) guideCount.textContent = guideCount.textContent.replace(/\d+\/\d+/, (guideStep + 1) + '/' + guidePanels.length);
      // Only the shown drawing animates; restarting the class replays it from the start (reduced motion: still drawing).
      guideArts.forEach((item, index) => {
        item.hidden = index !== guideStep;
        item.classList.remove('is-playing');
        if (index !== guideStep || reducedMotion) return;
        void item.getBoundingClientRect();
        item.classList.add('is-playing');
      });
      if (animate && !reducedMotion && previousStep !== guideStep && dialog.open) {
        animateGuideChange(previousStep, guideStep > previousStep ? 1 : -1);
      }
      const finalStep = guideStep === guidePanels.length - 1;
      if (guidePrevious) guidePrevious.disabled = guideStep === 0;
      if (guideForward) guideForward.disabled = finalStep;
      if (guideNext) guideNext.hidden = finalStep;
      if (startButton) startButton.hidden = !finalStep;
      if (guideSkip) guideSkip.hidden = finalStep;
      // Only a rescan within the hour (Measure Again) offers it; a first scan never shows it.
      if (someoneElse) someoneElse.hidden = !finalStep || recentScans().length === 0;
    }

    // One deliberate action per transition, including the final camera button.
    function acceptGuideAction() {
      const now = performance.now();
      if (now - guideActionAt < 360) return false;
      guideActionAt = now;
      return true;
    }

    function resetResultMotion() {
      if (!resultMotion) return;
      resultMotion.pause();
      resultMotion.hidden = true;
      try { resultMotion.currentTime = 0; } catch (error) {}
    }

    function playResultMotion() {
      if (!resultMotion) return;
      resultMotion.hidden = false;
      resultMotion.loop = true;
      hydrateMotion(resultMotion);
      if (!allowMotionVideo) return;
      try { resultMotion.currentTime = 0; } catch (error) {}
      const playPromise = resultMotion.play();
      if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(() => {});
    }

    function triggerSuccessHaptic() {
      if (successHapticPlayed || reducedMotion) return;
      successHapticPlayed = true;
      if (typeof navigator.vibrate !== 'function') return;
      try { navigator.vibrate([35, 45, 70]); } catch (error) {}
    }

    function privacyAnalytics(name) {
      try {
        const privacy = window.Shopify && window.Shopify.customerPrivacy;
        if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function' || !privacy.analyticsProcessingAllowed()) return;
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'face_fit_' + name });
      } catch (error) {}
    }

    function announceStatus(code) {
      statusTally[code] = (statusTally[code] || 0) + 1;
      const value = root.dataset['status' + code.charAt(0).toUpperCase() + code.slice(1)];
      if (value) scanStatus.textContent = value;
    }

    function decodeText(value) {
      const parser = document.createElement('textarea');
      parser.innerHTML = String(value || '');
      return parser.value;
    }

    function errorText(code) {
      const key = code === 'permission' ? 'errorPermission' : code === 'camera' ? 'errorCamera' : code === 'busy' ? 'errorBusy' : code === 'timeout' ? 'errorTimeout' : code === 'background' ? 'errorBackground' : 'errorModel';
      return root.dataset[key] || root.dataset.errorModel;
    }

    function setStage(name) {
      root.dataset.activeStage = name;
      const order = ['camera', 'align', 'measure', 'result'];
      const activeIndex = order.indexOf(name);
      stageSteps.forEach((step) => {
        const index = order.indexOf(step.dataset.stageStep);
        step.classList.toggle('is-complete', index >= 0 && index < activeIndex);
        if (index === activeIndex) step.setAttribute('aria-current', 'step');
        else step.removeAttribute('aria-current');
      });
      if (!scanHeading) return;
      const title = name === 'camera' ? root.dataset.stageCameraTitle : name === 'measure' ? root.dataset.stageMeasureTitle : root.dataset.stageAlignTitle;
      if (title) scanHeading.textContent = title;
    }

    function setScreen(name, focusSelector) {
      root.dataset.activeScreen = name;
      // "Choose size manually" is for a first-time visitor only (the purchase controller decides, assets/global.js).
      productInfo()?.faceFitPurchase?.syncManualLinks?.();
      root.querySelectorAll('[data-screen]').forEach((screen) => {
        screen.hidden = screen.dataset.screen !== name;
      });
      const focusTarget = focusSelector ? root.querySelector(focusSelector) : root.querySelector('[data-screen="' + name + '"] .face-fit__heading');
      if (focusTarget) requestAnimationFrame(() => focusTarget.focus({preventScroll: true}));
    }

    function storeAttempts() {
      attemptSessions.set(attemptSessionKey, {...scanAttempts});
      try { sessionStorage.setItem(attemptSessionKey, JSON.stringify(scanAttempts)); } catch {}
    }

    function startAttempt() {
      let previous = attemptSessions.get(attemptSessionKey);
      if (!previous) try { previous = JSON.parse(sessionStorage.getItem(attemptSessionKey)); } catch {}
      if (previous?.schema === 1 && Number.isSafeInteger(previous.attempts) && previous.attempts >= 0 &&
        Number.isSafeInteger(previous.failed) && previous.failed >= 0 && previous.failed <= previous.attempts) {
        scanAttempts = {schema:1, attempts:previous.attempts, retries:Math.max(0,previous.attempts-1), failed:previous.failed};
      }
      scanAttempts.attempts += 1;
      scanAttempts.retries = scanAttempts.attempts - 1;
      attemptRunning = true;
      statusTally = {};
      storeAttempts();
    }

    function failAttempt() {
      if (!attemptRunning) return;
      attemptRunning = false;
      scanAttempts.failed += 1;
      storeAttempts();
    }

    function completeAttempt() {
      if (!attemptRunning) return null;
      attemptRunning = false;
      return window.SpaceArmoryFitRules?.normalizeScanStats?.({...scanAttempts});
    }

    function stopMedia({preserveEngine = false} = {}) {
      // Closing/cancelling is not a failed scan. Terminal errors call failAttempt first.
      attemptRunning = false;
      generation += 1;
      guidePointer = null;
      stopGuideArt();
      root.classList.remove('face-fit--camera-ready');
      if (scanTimeout) window.clearTimeout(scanTimeout);
      scanTimeout = 0;
      if (cancelVideoMetadataWait) { const cancel = cancelVideoMetadataWait; cancelVideoMetadataWait = null; cancel(new Error('cancelled')); }
      if (frameCallback && video && typeof video.cancelVideoFrameCallback === 'function') video.cancelVideoFrameCallback(frameCallback);
      if (frameCallback && typeof window.cancelAnimationFrame === 'function') window.cancelAnimationFrame(frameCallback);
      frameCallback = 0;
      framePending = false;
      if (video) {
        video.pause();
        video.srcObject = null;
      }
      if (stream) {
        stream.getTracks().forEach((track) => track.stop());
        stream = null;
      }
      if (!preserveEngine) disposeInferenceEngine();
      mainThreadWarmupFrames = 0;
      mainThreadFrameCounter = 0;
      mainThreadIsDark = false;
      samples = [];
      if (progress) progress.value = 0;
      sessionStarting = false;
    }

    function finishDialogClose() {
      if (dialog.open || !bodyScrollLocked) return;
      bodyScrollLocked = false;
      stopMedia({preserveEngine: true});
      holdEngineAfterClose();
      document.body.style.overflow = previousBodyOverflow;
      root.dispatchEvent(new CustomEvent('space-armory:scanner-visibility', {bubbles: true}));
      if (focusAfterClose && opener && opener.isConnected) opener.focus();
    }

    function returnFocus({focus = true} = {}) {
      if (!dialog.open) return;
      focusAfterClose = focus;
      dialog.close();
      // The native close event is queued. Release our lock before the drawer
      // captures it, and prevent the late event from changing the drawer's lock.
      finishDialogClose();
    }

    // A loaded engine waits engineKeepAfterCloseMs for the next opening; one still loading stops now, as before.
    function holdEngineAfterClose() {
      cancelEngineRelease();
      const loaded = inferenceMode === 'main' ? !!mainThreadLandmarker : !!worker && !cancelWorkerInit;
      if (!loaded) {
        disposeInferenceEngine();
        return;
      }
      engineReleaseTimer = window.setTimeout(() => {
        engineReleaseTimer = 0;
        if (!dialog.open) disposeInferenceEngine();
      }, engineKeepAfterCloseMs);
    }

    function cancelEngineRelease() {
      if (engineReleaseTimer) window.clearTimeout(engineReleaseTimer);
      engineReleaseTimer = 0;
    }

    function disposeInferenceEngine() {
      cancelEngineRelease();
      engineGeneration += 1;
      enginePromise = null;
      if (cancelEnginePreparation) cancelEnginePreparation();
      cancelEnginePreparation = null;
      if (cancelWorkerInit) cancelWorkerInit();
      cancelWorkerInit = null;
      if (workerReadyTimer) window.clearTimeout(workerReadyTimer);
      workerReadyTimer = 0;
      if (worker) worker.terminate();
      worker = null;
      if (mainThreadLandmarker) {
        try { mainThreadLandmarker.close(); } catch (error) {}
      }
      mainThreadLandmarker = null;
      inferenceMode = 'worker';
    }

    function prepareInferenceEngine() {
      if (enginePromise) return enginePromise;
      const token = engineGeneration;
      let timer;
      const cancelled = new Promise((resolve, reject) => {
        cancelEnginePreparation = () => reject(new Error('cancelled'));
        timer = window.setTimeout(() => reject(new Error('model_timeout')), 45000);
      });
      enginePromise = Promise.race([createInferenceEngine(token), cancelled]).then((engine) => {
        if (token !== engineGeneration || !dialog.open) throw new Error('cancelled');
        return engine;
      }).catch((error) => {
        if (token === engineGeneration) disposeInferenceEngine();
        throw error;
      }).finally(() => {
        window.clearTimeout(timer);
        if (token === engineGeneration) cancelEnginePreparation = null;
      });
      return enginePromise;
    }

    function openDialog() {
      guideActionAt = -Infinity;
      if (dialog.open) return;
      cancelEngineRelease();
      focusAfterClose = true;
      previousBodyOverflow = document.body.style.overflow;
      bodyScrollLocked = true;
      document.body.style.overflow = 'hidden';
      setScreen('intro', '[data-close]');
      dialog.showModal();
      const preparingGeneration = engineGeneration;
      requestAnimationFrame(() => {
        window.setTimeout(() => {
          if (dialog.open && preparingGeneration === engineGeneration && root.dataset.activeScreen !== 'handoff') void prepareInferenceEngine().catch(() => {});
        }, 0);
      });
      root.dispatchEvent(new CustomEvent('space-armory:sizing-guide-opened', {bubbles: true, detail: {guide: 'camera'}}));
      root.dispatchEvent(new CustomEvent('space-armory:scanner-visibility', {bubbles: true}));
      setGuideStep(0, false);
      privacyAnalytics('open');
    }

    // Opening the window to measure: a computer or tablet goes straight to the QR code, without the phone guide or the
    // camera (owner, 18 Oct; assets/face-fit-device.js measuresOnPhone).
    function openForMeasuring() {
      openDialog();
      if (window.SpaceArmoryFitDevice?.measuresOnPhone?.()) void showPhoneHandoff();
    }

    async function showPhoneHandoff() {
      stopMedia();
      resetResultMotion();
      const token = generation;
      const qrImage = root.querySelector('[data-qr-image]');
      const qrStatus = root.querySelector('[data-qr-status]');
      const frame = root.querySelector('[data-qr-frame]');
      const link = root.querySelector('[data-handoff-link]');
      const copyButton = root.querySelector('[data-copy-handoff]');
      handoffUrl = '';
      qrImage.hidden = true;
      qrStatus.hidden = false;
      qrStatus.textContent = window.SA_I18N?.['scanner.qr_preparing'] ?? 'Preparing your QR code…';
      frame.setAttribute('aria-busy', 'true');
      copyButton.disabled = true;
      link.hidden = true;
      root.querySelector('[data-copy-status]').textContent = '';
      // A computer or tablet is told why (owner, 18 Oct); one without a camera reaches this screen as before, untold.
      const device = window.SpaceArmoryFitDevice;
      const reason = root.querySelector('[data-handoff-reason]');
      const elsewhere = !!device?.measuresOnPhone?.();
      reason.textContent = elsewhere ? (device.detect().type === 'Tablet' ? reason.dataset.tablet : reason.dataset.computer) || '' : '';
      reason.hidden = !reason.textContent;
      // Measure by Hand opens the string-and-ruler guide where the page has one; elsewhere the link leads to the sizes.
      const hand = root.querySelector('[data-screen="handoff"] [data-hand-guide]');
      const guideReady = typeof handGuide()?.open === 'function';
      if (!hand.dataset.manualLabel) hand.dataset.manualLabel = hand.textContent;
      hand.textContent = guideReady ? hand.dataset.handLabel : hand.dataset.manualLabel;
      hand.classList.toggle('is-hand', guideReady);
      setScreen('handoff');
      try {
        if (!handoffModules) handoffModules = Promise.all([
          import(root.dataset.handoffModuleUrl), import(root.dataset.qrModuleUrl)
        ]).catch((error) => { handoffModules = null; throw error; });
        const [handoff, qr] = await handoffModules;
        if (token !== generation || !dialog.open || root.dataset.activeScreen !== 'handoff') return;
        const form = productForm();
        const variant = form && form.querySelector('[name="id"]');
        const theme = (window.Shopify && window.Shopify.theme) || {};
        handoffUrl = handoff.buildPhoneUrl({
          currentUrl: window.location.href,
          productUrl: root.dataset.productUrl,
          productHandle: root.dataset.productHandle,
          themeId: theme.id || root.dataset.themeId,
          themeRole: theme.role || root.dataset.themeRole,
          variantId: variant && !variant.disabled ? variant.value : ''
        });
        link.href = handoffUrl;
        copyButton.disabled = false;
        qrImage.src = handoff.qrImageData(qr.default, handoffUrl);
        qrImage.hidden = false;
        qrStatus.hidden = true;
        privacyAnalytics('phone_handoff');
      } catch (error) {
        if (token !== generation || !dialog.open) return;
        qrStatus.textContent = window.SA_I18N?.['scanner.qr_failed'] ?? 'The QR code could not load. Close this window and try again.';
        if (handoffUrl) {
          link.href = handoffUrl;
          link.hidden = false;
          copyButton.disabled = false;
        }
      } finally {
        if (token === generation) frame.setAttribute('aria-busy', 'false');
      }
    }

    async function copyPhoneLink() {
      if (!handoffUrl) return;
      const status = root.querySelector('[data-copy-status]');
      try {
        await navigator.clipboard.writeText(handoffUrl);
        status.textContent = window.SA_I18N?.['scanner.link_copied'] ?? 'Link copied. Open it on your phone.';
      } catch (error) {
        const link = root.querySelector('[data-handoff-link]');
        link.href = handoffUrl;
        link.hidden = false;
        status.textContent = window.SA_I18N?.['scanner.link_manual'] ?? 'Use the link below to copy or share it to your phone.';
      }
    }

    function showPhoneReady() {
      stopMedia();
      setScreen('phone-ready');
    }

    // No camera to open (owner, 11 Oct 2026): a phone or tablet shows the camera error with the manual option, never
    // "Continue on your phone"; only a computer without a camera gets the QR code to measure on a phone.
    async function showNoCamera() {
      if (isPhoneOrTablet()) showError('camera');
      else await showPhoneHandoff();
    }

    // The device type the order context reports (assets/face-fit-device.js); an unknown one counts as a phone or tablet
    // when its only pointer is a touchscreen (no mouse or trackpad).
    function isPhoneOrTablet() {
      const type = window.SpaceArmoryFitDevice?.detect().type;
      if (type === 'Phone' || type === 'Tablet') return true;
      if (type === 'Desktop') return false;
      return !!window.matchMedia?.('(hover: none) and (pointer: coarse)').matches;
    }

    const errorScreen = root.querySelector('[data-screen="error"]');
    const errorTips = errorScreen.querySelector('.face-fit__tips');
    const errorTipItems = Array.from(errorTips.children);
    const errorRetry = errorScreen.querySelector('[data-retry]');
    const errorHand = errorScreen.querySelector('[data-error-hand]');
    const errorRetryLabel = errorRetry.textContent;
    const errorHandLabel = errorHand.textContent;
    // The camera hint shown most during the failed scan picks the one tip (icons: 0 light, 1 framing, 2 eyes).
    const tipFor = {close: ['tipClose', 1], far: ['tipFar', 1], eyes: ['tipEyes', 2], turn: ['tipTurn', 1], dark: ['tipDark', 0],
      center: ['tipCenter', 1], partial: ['tipCenter', 1], face: ['tipCenter', 1], multiple: ['statusMultiple', 1], focus: ['tipStill', 1],
      glare: ['statusGlare', 0]};

    function handGuide() {
      return root.parentElement?.querySelector('manual-size-guide') || null;
    }

    function showErrorTip(code) {
      if (code !== 'timeout' && code !== 'quality') { errorTips.replaceChildren(...errorTipItems); return; }
      const [top, count] = Object.entries(statusTally).filter(([key]) => key in tipFor).sort((a, b) => b[1] - a[1])[0] || [];
      const [key, icon] = count >= 15 ? tipFor[top] : code === 'quality' ? ['tipStill', 1] : ['tipCenter', 1];
      const text = (key.startsWith('status') ? root.dataset[key] : errorScreen.dataset[key]) || '';
      if (!text) { errorTips.replaceChildren(...errorTipItems); return; }
      const item = errorTipItems[icon].cloneNode(true);
      item.lastChild.textContent = text;
      errorTips.replaceChildren(item);
    }

    // Retry first; Measure by Hand from the second failure in a row and first from the third. A device whose camera or
    // browser cannot measure gets it first at once, since a retry cannot work there.
    function arrangeErrorActions(code, blocked) {
      const cannotMeasure = code === 'camera' || code === 'model';
      const handFirst = cannotMeasure || errorStreak >= 3;
      // A data attribute, not [hidden]: the purchase controller sets [hidden] on every manual link for a visitor who
      // already has a measurement (global.js syncManualLinks), and both rules apply.
      errorScreen.dataset.hand = cannotMeasure || errorStreak >= 2 ? 'on' : 'off';
      errorHand.textContent = typeof handGuide()?.open === 'function' ? (errorScreen.dataset.handLabel || errorHandLabel) : errorHandLabel;
      errorHand.className = handFirst ? 'face-fit__button face-fit__button--error' : 'face-fit__manual-link';
      errorRetry.className = handFirst ? 'face-fit__manual-link' : 'face-fit__button face-fit__button--error';
      errorHand.style.order = handFirst ? '-1' : '';
      errorRetry.textContent = code !== 'permission' ? errorRetryLabel
        : (blocked ? errorScreen.dataset.tryAgain : errorScreen.dataset.allowCamera) || errorRetryLabel;
    }

    // A refused camera: the browser can usually ask again ("prompt"), so Allow Camera re-opens its own question. Only a
    // browser set to block the camera ("denied", or a second refusal that came back at once with no question) gets the
    // settings steps for this phone.
    async function cameraBlocked() {
      let state = '';
      try { state = (await Promise.race([navigator.permissions?.query({name: 'camera'}), new Promise((resolve) => setTimeout(resolve, 300))]))?.state || ''; } catch {}
      if (state === 'denied') return true;
      if (state === 'granted') return false;
      return permissionFailures > 1 && performance.now() - cameraRequestedAt < 400;
    }

    function blockedSteps() {
      const ua = navigator.userAgent;
      const ios = /iPhone|iPad|iPod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
      const inApp = /FBAN|FBAV|Instagram|GSA\/|; wv\)/.test(ua);
      const key = ios ? (inApp || /CriOS|FxiOS|EdgiOS/.test(ua) ? 'blockedIosApp' : 'blockedIosSafari')
        : /Android/.test(ua) ? (inApp ? 'blockedAndroidApp' : 'blockedAndroid') : 'blockedOther';
      return [errorScreen.dataset.blockedIntro, errorScreen.dataset[key]].filter(Boolean).join(' ');
    }

    function showError(code) {
      failAttempt();
      stopMedia();
      if (code !== 'background') errorStreak += 1;
      if (code === 'permission') permissionFailures += 1;
      root.dataset.errorCode = code;
      const titles = {permission: 'Camera access needed', camera: 'Camera unavailable', busy: 'Camera is busy', timeout: 'Measurement timed out', background: 'Measurement interrupted', quality: 'Try measuring again'};
      // French, Spanish and German pages: the same headings from window.SA_I18N (snippets/sa-i18n-js.liquid).
      const heading = root.querySelector('[data-error-heading]');
      heading.textContent = window.SA_I18N?.[`scanner.error_${code}`] ?? titles[code] ?? window.SA_I18N?.['scanner.error_title'] ?? 'Unable to start measurement';
      errorMessage.textContent = code === 'quality'
        ? (window.SA_I18N?.['scanner.quality_message'] ?? 'We couldn’t get a reliable measurement. Face the camera in even light, keep still, and try again.')
        : code === 'timeout' && errorStreak < 2 && errorScreen.dataset.timeoutShort ? errorScreen.dataset.timeoutShort
        : code === 'permission' && errorScreen.dataset.allowMessage ? errorScreen.dataset.allowMessage
        : errorText(code);
      showErrorTip(code);
      arrangeErrorActions(code, false);
      if (code !== 'permission') { setScreen('error', '[data-error-heading]'); return; }
      cameraBlocked().then((blocked) => {
        if (blocked && root.dataset.errorCode === 'permission') {
          heading.textContent = errorScreen.dataset.blockedTitle || heading.textContent;
          errorMessage.textContent = blockedSteps() || errorText(code);
          arrangeErrorActions(code, true);
        }
      }).finally(() => { if (root.dataset.errorCode === 'permission') setScreen('error', '[data-error-heading]'); });
    }

    function createWorker(token) {
      const instance = new Worker(root.dataset.workerUrl);
      worker = instance;
      return new Promise((resolve, reject) => {
        let workerReady = false;
        workerReadyTimer = window.setTimeout(() => { workerReadyTimer = 0; cancelWorkerInit = null; reject(new Error('worker_timeout')); }, 30000);
        cancelWorkerInit = () => { if (workerReadyTimer) window.clearTimeout(workerReadyTimer); workerReadyTimer = 0; reject(new Error('cancelled')); };
        instance.onmessage = (event) => {
          if (token !== engineGeneration || worker !== instance) return;
          const data = event.data || {};
          if (data.type === 'ready') {
            if (workerReadyTimer) window.clearTimeout(workerReadyTimer);
            workerReadyTimer = 0;
            cancelWorkerInit = null;
            workerReady = true;
            resolve(instance);
          } else if (data.type === 'init-error') {
            if (workerReadyTimer) window.clearTimeout(workerReadyTimer);
            workerReadyTimer = 0;
            cancelWorkerInit = null;
            if (data.error) console.error('[Face Fit] MediaPipe initialization failed:', data.error.name, data.error.message);
            reject(new Error('worker_init'));
          } else if (data.type === 'result') {
            if (data.generation === generation && stream && dialog.open) onWorkerResult(data);
          } else if (data.type === 'detect-error' && data.generation === generation && stream) {
            framePending = false;
            scanStatus.textContent = root.dataset.statusHold;
          }
        };
        instance.onerror = () => {
          if (token !== engineGeneration || worker !== instance) return;
          if (!workerReady) {
            if (workerReadyTimer) window.clearTimeout(workerReadyTimer);
            workerReadyTimer = 0;
            cancelWorkerInit = null;
            reject(new Error('worker_error'));
          } else if (dialog.open) {
            showError('model');
          }
        };
        // The worker imports the iris ruler from this versioned URL (the bare file name stays cached for a year).
        let irisUrl = '';
        try { irisUrl = root.dataset.irisScriptUrl ? new URL(root.dataset.irisScriptUrl, window.location.href).href : ''; } catch (error) {}
        instance.postMessage({ type: 'init', irisUrl });
      });
    }

    function shouldUseMainThreadInference() {
      const userAgent = navigator.userAgent || '';
      const isiOS = /iPhone|iPad|iPod/i.test(userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
      const isSafari = /Safari/i.test(userAgent) && !/Chrome|CriOS|Chromium|Edg|OPR|FxiOS/i.test(userAgent);
      return isiOS || isSafari;
    }

    // The iris ruler on the page: both paths need its stable() for the scan result, and the iPhone/Safari path also measures
    // with it. If it cannot load, today's width runs on its own.
    let irisRulerLoad = null;
    function loadIrisRuler() {
      if (window.SpaceArmoryFitIris || !root.dataset.irisScriptUrl) return Promise.resolve();
      irisRulerLoad ||= new Promise((resolve) => {
        const script = document.createElement('script');
        script.src = root.dataset.irisScriptUrl;
        script.async = true;
        script.onload = () => resolve();
        script.onerror = () => { irisRulerLoad = null; resolve(); };
        document.head.appendChild(script);
      });
      return irisRulerLoad;
    }

    async function createMainThreadLandmarker(token) {
      const vision = await import(root.dataset.visionModuleUrl);
      const moduleUrl = new URL(root.dataset.visionModuleUrl, window.location.href);
      const assetRoot = new URL('./', moduleUrl).href.replace(/\/$/, '');
      const files = await vision.FilesetResolver.forVisionTasks(assetRoot);
      if (token !== engineGeneration || !dialog.open) throw new Error('cancelled');
      const landmarker = await vision.FaceLandmarker.createFromOptions(files, {
        baseOptions: { modelAssetPath: root.dataset.modelUrl },
        runningMode: 'VIDEO',
        numFaces: 1,
        minFaceDetectionConfidence: 0.5,
        minFacePresenceConfidence: 0.5,
        minTrackingConfidence: 0.5,
        outputFaceBlendshapes: false,
        outputFacialTransformationMatrixes: false
      });
      if (token !== engineGeneration || !dialog.open) {
        landmarker.close();
        throw new Error('cancelled');
      }
      mainThreadLandmarker = landmarker;
      inferenceMode = 'main';
      return landmarker;
    }

    async function createInferenceEngine(token) {
      // The ruler loads beside the engine and is in place before the first frame; a stuck request holds it at most 4 s.
      const rulerReady = Promise.race([loadIrisRuler(), new Promise((resolve) => setTimeout(resolve, 4000))]);
      if (!shouldUseMainThreadInference()) {
        try {
          const readyWorker = await createWorker(token);
          await rulerReady;
          inferenceMode = 'worker';
          return readyWorker;
        } catch (error) {
          if (token !== engineGeneration || !dialog.open) throw new Error('cancelled');
          if (worker) worker.terminate();
          worker = null;
          console.warn('[Face Fit] Worker unavailable; using the browser-compatible fallback.');
        }
      }
      const landmarker = await createMainThreadLandmarker(token);
      await rulerReady;
      return landmarker;
    }

    function distance3d(a, b, width, height) {
      const dx = (a.x - b.x) * width;
      const dy = (a.y - b.y) * height;
      const dz = (a.z - b.z) * width;
      return Math.sqrt(dx * dx + dy * dy + dz * dz);
    }

    function eyeAspectRatio(points, width, height) {
      const vertical1 = distance3d(points[1], points[5], width, height);
      const vertical2 = distance3d(points[2], points[4], width, height);
      const horizontal = distance3d(points[0], points[3], width, height);
      return (vertical1 + vertical2) / (2 * horizontal);
    }

    function sampleMainThreadLight() {
      mainThreadFrameCounter += 1;
      if (mainThreadFrameCounter % 15 !== 0) return mainThreadIsDark;
      if (!lightCanvas) {
        lightCanvas = document.createElement('canvas');
        lightCanvas.width = 32;
        lightCanvas.height = 24;
        lightContext = lightCanvas.getContext('2d', { willReadFrequently: true });
      }
      if (!lightContext) return false;
      lightContext.drawImage(video, 0, 0, 32, 24);
      const pixels = lightContext.getImageData(0, 0, 32, 24).data;
      let luminance = 0;
      for (let index = 0; index < pixels.length; index += 4) {
        luminance += 0.299 * pixels[index] + 0.587 * pixels[index + 1] + 0.114 * pixels[index + 2];
      }
      mainThreadIsDark = luminance / (pixels.length / 4) < 30;
      return mainThreadIsDark;
    }

    function analyzeMainThreadFrame(now) {
      if (sampleMainThreadLight()) return { status: 'dark' };
      const result = mainThreadLandmarker.detectForVideo(video, now);
      const faces = result.faceLandmarks || [];
      if (faces.length !== 1) return { status: faces.length > 1 ? 'multiple' : 'face' };

      mainThreadWarmupFrames += 1;
      if (mainThreadWarmupFrames < warmupTarget) return { status: 'warming' };

      const points = faces[0];
      const nose = points[1];
      const leftCheek = points[234];
      const rightCheek = points[454];
      const top = points[10];
      const chin = points[152];
      const leftIrisEdge = points[469];
      const rightIrisEdge = points[471];
      const earPoint = points[127];
      const required = [nose, leftCheek, rightCheek, top, chin, leftIrisEdge, rightIrisEdge, earPoint];
      if (required.some((point) => !point)) return { status: 'face' };
      if (leftCheek.x < 0.05 || rightCheek.x > 0.95 || top.y < 0.05 || chin.y > 0.95) return { status: 'partial' };

      const faceWidthRatio = rightCheek.x - leftCheek.x;
      if (faceWidthRatio < 0.26) return { status: 'far' };
      if (faceWidthRatio > 0.36) return { status: 'close' };

      const centerX = (leftCheek.x + rightCheek.x) / 2;
      const centerY = (top.y + chin.y) / 2;
      if (centerX < 0.4 || centerX > 0.6 || centerY < 0.35 || centerY > 0.65) return { status: 'center' };

      const horizontalSymmetry = Math.abs(nose.x - leftCheek.x) / Math.max(Math.abs(rightCheek.x - nose.x), 0.001);
      const verticalSymmetry = Math.abs(nose.y - top.y) / Math.max(Math.abs(chin.y - nose.y), 0.001);
      if (horizontalSymmetry < 0.7 || horizontalSymmetry > 1.4 || verticalSymmetry < 0.7 || verticalSymmetry > 1.45) return { status: 'turn' };

      const leftEye = [points[33], points[160], points[158], points[133], points[153], points[144]];
      const rightEye = [points[362], points[385], points[387], points[263], points[373], points[380]];
      if (leftEye.some((point) => !point) || rightEye.some((point) => !point)) return { status: 'face' };
      if (eyeAspectRatio(leftEye, video.videoWidth, video.videoHeight) < 0.2 || eyeAspectRatio(rightEye, video.videoWidth, video.videoHeight) < 0.2) return { status: 'eyes' };

      const irisDistance = distance3d(leftIrisEdge, rightIrisEdge, video.videoWidth, video.videoHeight);
      if (irisDistance < 0.1 || !Number.isFinite(irisDistance)) return { status: 'focus' };

      const measuredCm = distance3d(nose, earPoint, video.videoWidth, video.videoHeight)
        * (referenceIrisDiameterCm / irisDistance)
        * maskCurveFactor;
      if (!Number.isFinite(measuredCm) || measuredCm <= 5 || measuredCm >= 40) return { status: 'focus' };
      // Today's width above is untouched; the iris ruler's width rides along (face-fit-iris.js).
      let iris = null;
      if (window.SpaceArmoryFitIris) {
        try {
          const width = video.videoWidth, height = video.videoHeight;
          if (!irisCanvas) { irisCanvas = document.createElement('canvas'); irisContext = null; }
          if (irisCanvas.width !== width || irisCanvas.height !== height) { irisCanvas.width = width; irisCanvas.height = height; irisContext = null; }
          irisContext ||= irisCanvas.getContext('2d', { willReadFrequently: true });
          irisContext.drawImage(video, 0, 0, width, height);
          iris = window.SpaceArmoryFitIris.measure(points, width, height, irisContext.getImageData(0, 0, width, height).data);
        } catch (error) {
          iris = null;
        }
      }
      return { status: 'aligned', value: measuredCm, iris };
    }

    function launchFrameLoop(token) {
      const schedule = () => {
        if (token !== generation || !stream || !dialog.open) return;
        if (typeof video.requestVideoFrameCallback === 'function') {
          frameCallback = video.requestVideoFrameCallback((now) => {
            processFrame(now, token);
            schedule();
          });
        } else {
          frameCallback = requestAnimationFrame((now) => {
            processFrame(now, token);
            schedule();
          });
        }
      };
      schedule();
    }

    async function revealStablePreview(token, previewStartedAt) {
      const minimumWait = Math.max(0, 1000 - (performance.now() - previewStartedAt));
      const delay = new Promise((resolve) => window.setTimeout(resolve, minimumWait));
      const frames = new Promise((resolve) => {
        let count = 0;
        let done = false;
        const finish = () => {
          if (done) return;
          done = true;
          resolve();
        };
        const fallback = window.setTimeout(finish, 900);
        const next = () => {
          if (done) return;
          if (token !== generation || !stream || !dialog.open) {
            window.clearTimeout(fallback);
            finish();
            return;
          }
          count += 1;
          if (count >= 1) {
            window.clearTimeout(fallback);
            finish();
            return;
          }
          if (typeof video.requestVideoFrameCallback === 'function') video.requestVideoFrameCallback(next);
          else requestAnimationFrame(next);
        };
        if (typeof video.requestVideoFrameCallback === 'function') video.requestVideoFrameCallback(next);
        else requestAnimationFrame(next);
      });
      await Promise.all([delay, frames]);
      if (token === generation && stream && dialog.open) root.classList.add('face-fit--camera-ready');
    }

    async function processFrame(now, token) {
      if (token !== generation || framePending || (!worker && !mainThreadLandmarker) || !video.videoWidth) return;
      if (now - lastFrameAt < frameIntervalMs) return;
      lastFrameAt = now;
      framePending = true;
      if (inferenceMode === 'main') {
        try {
          const data = analyzeMainThreadFrame(now);
          if (token === generation && dialog.open) onWorkerResult(data);
          else framePending = false;
        } catch (error) {
          framePending = false;
          scanStatus.textContent = root.dataset.statusHold;
          console.error('[Face Fit] Browser fallback frame failed:', error);
        }
        return;
      }
      try {
        const bitmap = await createImageBitmap(video);
        if (token !== generation || !worker) {
          bitmap.close();
          framePending = false;
          return;
        }
        worker.postMessage({ type: 'frame', bitmap, timestamp: now, generation: token }, [bitmap]);
      } catch (error) {
        framePending = false;
      }
    }

    function onWorkerResult(data) {
      framePending = false;
      if (data.status !== 'aligned') {
        setStage('align');
        const statusMap = { warming: 'warming', multiple: 'multiple', face: 'face', partial: 'partial', far: 'far', close: 'close', center: 'center', turn: 'turn', eyes: 'eyes', focus: 'focus', dark: 'dark' };
        announceStatus(statusMap[data.status] || 'face');
        return;
      }
      setStage('measure');
      announceStatus('measuring');
      const now = performance.now();
      if (samples.length && now - lastSampleAt > sampleGapMs) { samples = []; irisFrames = []; unsteadyFrames = 0; glareOn = false; steadyToday = null; }
      lastSampleAt = now;
      samples.push(data.value);
      irisFrames.push(data.iris && typeof data.iris === 'object' ? {cm: Number(data.iris.cm), agree: !!data.iris.agree, a: Number(data.iris.a), b: Number(data.iris.b)} : null);
      if (samples.length > targetSamples) samples = samples.slice(-targetSamples);
      if (irisFrames.length > targetSamples) irisFrames = irisFrames.slice(-targetSamples);
      progress.value = Math.min(samples.length, targetSamples);
      const percent = Math.round((samples.length / targetSamples) * 100);
      if (samples.length < targetSamples && glareInEyes()) { glareShown = true; announceStatus('glare'); }
      else scanStatus.textContent = root.dataset.progressTemplate.replace('__PERCENT__', String(percent));
      if (samples.length >= targetSamples) finishScan();
    }

    // Owner, 19 Oct night: a lamp in front of the face puts a highlight on one iris and the two eyes stop agreeing. When
    // under 40% of the newest 20 frames (at least 16 carrying an iris width) have both eyes agreeing, the shopper is asked
    // to turn from the light, so the iris can measure the right size instead of the scan falling back to today's width.
    // The hint stays until half of them agree again (or under 10 carry a width), so it does not flicker; a face in plain
    // light agrees in 75-90%. Only with the page's ruler loaded, as scanResult needs it to use the iris at all.
    function glareInEyes() {
      if (root.dataset.irisMode !== 'live' || !window.SpaceArmoryFitIris) return false;
      const recent = irisFrames.slice(-20).filter((frame) => frame && Number.isFinite(frame.cm));
      const share = recent.length >= (glareOn ? 10 : 16) ? recent.filter((frame) => frame.agree).length / recent.length : 1;
      glareOn = share < (glareOn ? 0.5 : 0.4);
      return glareOn;
    }

    function median(values) {
      const sorted = values.slice().sort((a, b) => a - b);
      const middle = Math.floor(sorted.length / 2);
      return sorted.length % 2 ? sorted[middle] : (sorted[middle - 1] + sorted[middle]) / 2;
    }

    function classify(values) {
      if (values.length < targetSamples) return { reason: 'samples' };
      const center = window.SpaceArmoryFitRules?.stable(values);
      return {size: window.SpaceArmoryFitRules?.sizeFor(center), metric: center};
    }

    function productSection() {
      const id = root.dataset.sectionId;
      return id ? document.getElementById('shopify-section-' + id) : root.closest('section');
    }

    function productInfo() {
      const section = productSection();
      if (!section) return null;
      return section.querySelector('product-info') || section;
    }

    function productForm() {
      const scope = productInfo();
      return scope && (
        scope.querySelector('product-form form[action*="/cart/add"]') ||
        scope.querySelector('form[data-type="add-to-cart-form"]')
      );
    }

    function storedMeasurement() {
      try {
        return sessionStorage.getItem(measurementStorageKey) || sessionStorage.getItem(legacyMeasurementStorageKey) || '';
      } catch (error) {
        return '';
      }
    }

    function storedMeasurementSource() {
      try {
        return sessionStorage.getItem(measurementSourceStorageKey) || sessionStorage.getItem(legacySourceStorageKey) || '';
      } catch (error) {
        return '';
      }
    }

    function setLineItemProperty(form, name, value) {
      if (!form || !value) return;
      let input = Array.from(form.querySelectorAll('input[name^="properties["]')).find((item) => item.name === 'properties[' + name + ']');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[' + name + ']';
        form.appendChild(input);
      }
      input.value = value;
    }

    function removeLineItemProperty(name) {
      document.querySelectorAll('input[name^="properties["]').forEach((input) => {
        if (input.name === 'properties[' + name + ']') input.remove();
      });
    }

    function clearStoredMeasurement() {
      try {
        [measurementStorageKey, measurementSourceStorageKey, measurementDeviceStorageKey, measurementStatsStorageKey, compareStorageKey, legacyMeasurementStorageKey, legacySourceStorageKey].forEach((key) => sessionStorage.removeItem(key));
      } catch (error) {}
    }

    function attachMeasurementStats(form, stats) {
      if (!form) return;
      (window.SpaceArmoryFitRules?.scanStatsKeys || []).forEach(name => {
        form.querySelector('input[name="properties[' + name + ']"]')?.remove();
      });
      Object.entries(window.SpaceArmoryFitRules?.scanStatsProperties?.(stats) || {}).forEach(([name,value]) => setLineItemProperty(form,name,value));
    }

    function attachPendingMeasurement(form) {
      const value = storedMeasurement();
      const source = storedMeasurementSource();
      const product = root.dataset.productHandle || root.dataset.productId || '';
      if (!form || !value) return;
      if (!source || source !== product) {
        clearStoredMeasurement();
        const measurementInput = form.querySelector('input[name="properties[' + measurementPropertyName + ']"]');
        if (measurementInput) measurementInput.remove();
        const sourceInput = form.querySelector('input[name="properties[' + scanSourcePropertyName + ']"]');
        if (sourceInput && sourceInput.value.startsWith('auto_result |')) {
          sourceInput.remove();
          form.querySelector('input[name="properties[' + scanDevicePropertyName + ']"]')?.remove();
          form.querySelector('input[name="properties[' + scanActionPropertyName + ']"]')?.remove();
          attachMeasurementStats(form, null);
        }
        return;
      }
      if (form.querySelector('input[name="properties[' + measuredPropertyName + ']"]')) return;
      setLineItemProperty(form, measurementPropertyName, value);
      setLineItemProperty(form, scanSourcePropertyName, 'auto_result | ' + source + ' | ' + sourceVersion);
      form.querySelector('input[name="properties[' + scanDevicePropertyName + ']"]')?.remove();
      try {
        const device = JSON.parse(sessionStorage.getItem(measurementDeviceStorageKey));
        setLineItemProperty(form, scanDevicePropertyName, window.SpaceArmoryFitDevice?.text(device));
      } catch {}
      let stats;
      try { stats = JSON.parse(sessionStorage.getItem(measurementStatsStorageKey)); } catch {}
      attachMeasurementStats(form, stats);
      let compare = '';
      try { compare = sessionStorage.getItem(compareStorageKey) || ''; } catch {}
      if (compare) setLineItemProperty(form, comparePropertyName, compare);
      else form.querySelector('input[name="properties[' + comparePropertyName + ']"]')?.remove();
    }

    function prepareMeasurementForCart(form) {
      attachPendingMeasurement(form);
      if (!form || form.querySelector('input[name="properties[' + scanActionPropertyName + ']"]')?.value) return;
      const source = form.querySelector('input[name="properties[' + scanSourcePropertyName + ']"]')?.value || '';
      const value = form.querySelector('input[name="properties[' + measuredPropertyName + ']"]')?.value ||
        form.querySelector('input[name="properties[' + measurementPropertyName + ']"]')?.value;
      // Result-button and saved-profile actions keep their own attribution.
      // A normal product-page add is labelled only when a measurement is attached.
      if (value && /^(auto_result|applied) \| /.test(source)) {
        setLineItemProperty(form, scanActionPropertyName, 'Add to Cart from product page after measurement');
      }
    }

    function savePendingMeasurement(value) {
      try {
        clearStoredMeasurement();
        sessionStorage.setItem(measurementStorageKey, value);
        sessionStorage.setItem(measurementSourceStorageKey, root.dataset.productHandle || root.dataset.productId || 'unknown-product');
        if (activeMeasurementDevice) sessionStorage.setItem(measurementDeviceStorageKey, JSON.stringify(activeMeasurementDevice));
        if (activeMeasurementStats) sessionStorage.setItem(measurementStatsStorageKey, JSON.stringify(activeMeasurementStats));
        if (activeCompareText) sessionStorage.setItem(compareStorageKey, activeCompareText);
      } catch (error) {}
      attachPendingMeasurement(productForm());
    }

    // The order line "Measured Size" as the shopper reads it in the cart, checkout, the order and its emails (owner,
    // 11 Oct 2026): the visitor's unit only (data-size-unit), "5.67 in - L" on the United States country, "14.4 cm - L"
    // elsewhere, from the full text "14.4 cm / 5.67 in - L" that _Face Fit Width keeps.
    function measuredSizeText(text) {
      const match = String(text).match(/^(\d+(?:\.\d+)?) cm \/ (\d+(?:\.\d+)?) in - (S|M|L|XL|XXL)$/);
      if (!match) return text;
      return root.dataset.sizeUnit === 'in' ? `${match[2]} in - ${match[3]}` : `${match[1]} cm - ${match[3]}`;
    }

    function useMeasuredSizeProperty(form, action) {
      if (!form || !activeMeasurementText) return;
      clearStoredMeasurement();
      removeLineItemProperty(measurementPropertyName);
      removeLineItemProperty(scanSourcePropertyName);
      setLineItemProperty(form, measuredPropertyName, measuredSizeText(activeMeasurementText));
      setLineItemProperty(form, widthPropertyName, activeMeasurementText);
      setLineItemProperty(form, scanSourcePropertyName, 'applied | ' + (root.dataset.productHandle || root.dataset.productId || 'unknown-product') + ' | ' + sourceVersion);
      setLineItemProperty(form, scanActionPropertyName, action);
      removeLineItemProperty(scanDevicePropertyName);
      setLineItemProperty(form, scanDevicePropertyName, window.SpaceArmoryFitDevice?.text(activeMeasurementDevice));
      attachMeasurementStats(form, activeMeasurementStats);
      removeLineItemProperty(comparePropertyName);
      if (activeCompareText) setLineItemProperty(form, comparePropertyName, activeCompareText);
    }

    // Applying the result keeps it for every mask page (assets/face-fit-memory.js through the purchase controller).
    // Only these two buttons write; a result that is only shown, or a rejected scan, keeps nothing.
    function rememberAppliedMeasurement() {
      if (!activeRecord) return;
      const {cm, method, measuredAt} = activeRecord;
      productInfo()?.faceFitPurchase?.remember?.({cm, method, measuredAt});
    }

    function normalize(value) {
      return String(value || '').trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, ' ');
    }

    function sizeAliases(size) {
      const aliases = {
        s: ['s', 'small', 'small size'],
        m: ['m', 'medium', 'medium size'],
        l: ['l', 'large', 'large size'],
        xl: ['xl', 'x-large', 'extra large', 'x large'],
        xxl: ['xxl', '2xl', 'xx-large', 'extra extra large', 'double xl']
      };
      return aliases[normalize(size)] || [normalize(size)];
    }

    function optionName(control) {
      const nameMatch = String(control.name || '').match(/^options\[(.+)\]$/i);
      if (nameMatch) return nameMatch[1];
      const fieldset = control.closest('fieldset');
      const legend = fieldset && fieldset.querySelector('legend');
      if (control.dataset.optionName) return control.dataset.optionName;
      if (legend) return legend.textContent;
      if (control.getAttribute('aria-label')) return control.getAttribute('aria-label');
      const id = control.id && document.querySelector('label[for="' + CSS.escape(control.id) + '"]');
      return id ? id.textContent : '';
    }

    function isAvailable(control) {
      if (control.disabled || control.classList.contains('disabled')) return false;
      if (control.tagName === 'SELECT') {
        const selected = Array.from(control.options).find((option) => option.value === control.value);
        return !!selected && !selected.disabled;
      }
      const labels = [];
      if (control.id) {
        const label = document.querySelector('label[for="' + CSS.escape(control.id) + '"]');
        if (label) labels.push(label);
      }
      if (control.parentElement && control.parentElement.tagName === 'LABEL') labels.push(control.parentElement);
      return !labels.some((label) => label.classList.contains('label-unavailable') || label.classList.contains('disabled'));
    }

    function findSizeControl(info, size) {
      if (!info) return null;
      const accepted = sizeAliases(size);
      const controls = Array.from(info.querySelectorAll(
        'input[type="radio"][data-option-name], input[type="radio"][name^="options"], select[data-option-name], select[name^="options"]'
      ));
      const matchesOption = (control) => root.dataset.bundleSizes === 'true'
        ? control.closest('.product-form__input') === info.faceFitPurchase?.groups()[info.faceFitPurchase.sizeIndex]
        : /^(size|fit|beden|size fit|taille|talla|größe|groesse|taglia)$/.test(normalize(optionName(control)));
      for (const control of controls) {
        if (!matchesOption(control)) continue;
        if (control.tagName === 'SELECT') {
          const option = Array.from(control.options).find((item) => accepted.includes(normalize(item.value)));
          if (option) return { control, value: option.value, available: !option.disabled, info };
        } else if (accepted.includes(normalize(control.value))) {
          return { control, value: control.value, available: isAvailable(control), info };
        }
      }
      return null;
    }

    function sizeOptionIndex() {
      if (root.dataset.bundleSizes === 'true') return productInfo()?.faceFitPurchase?.sizeIndex ?? -1;
      try {
        const names = JSON.parse(root.dataset.productOptions || '[]');
        return names.findIndex((name) => /^(size|fit|beden|size fit|taille|talla|größe|groesse|taglia)$/.test(normalize(name)));
      } catch (error) {
        return -1;
      }
    }

    function nativeEvents() {
      return {
        subscribe: typeof window.subscribe === 'function' ? window.subscribe : (typeof subscribe === 'function' ? subscribe : null),
        names: window.PUB_SUB_EVENTS || (typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS : null)
      };
    }

    let productVariantsCache;

    function productVariants() {
      if (productVariantsCache) return productVariantsCache;
      try {
        productVariantsCache = JSON.parse(root.querySelector('[data-face-fit-variants]')?.textContent || '[]');
      } catch (error) {
        productVariantsCache = [];
      }
      return productVariantsCache;
    }

    function selectedOptionValues(info) {
      const picker = info && info.querySelector('variant-selects');
      if (!picker) return [];
      return Array.from(picker.querySelectorAll('fieldset, .product-form__input--dropdown')).map((group) => {
        const selected = group.querySelector('input:checked') || group.querySelector('select')?.selectedOptions?.[0];
        return selected ? selected.value : '';
      });
    }

    function variantForSize(info, size) {
      const optionIndex = sizeOptionIndex();
      if (optionIndex < 0) return null;
      const selected = selectedOptionValues(info);
      const accepted = sizeAliases(size);
      return productVariants().find((variant) => Array.isArray(variant.options) && variant.options.every((value, index) => {
        if (index === optionIndex) return accepted.includes(normalize(value));
        if (root.dataset.bundleSizes === 'true' && !selected[index]) return true;
        return !!selected[index] && normalize(selected[index]) === normalize(value);
      })) || null;
    }

    function selectRecommendedSize() {
      const purchase = productInfo()?.faceFitPurchase;
      if (!purchase) throw new Error('variant_missing');
      const selected = purchase.applySize(activeSize);
      activeVariantId = String(selected.variant.id);
      return selected;
    }

    // 'live' shows the iris width when at least 20 of the 60 frames carried one; otherwise (ruler missing or the iris not
    // found) this scan falls back to today's width. An iris width that is still unsteady on the last rolling frame (window
    // reflections in the eyes) also falls back to today's width, so live mode ends on the error screen only when today's
    // width is unsteady too. When the two eyes agree in fewer than 35 of the 60 frames (a lamp in front of the face puts
    // a highlight on an iris), one eye alone is not trusted: the scan rolls on with the light hint so both eyes can
    // agree again, and on the last rolling frame shows today's steady width, the steadier eye only when today's width is
    // unsteady (owner's family test, 19 Oct night: lamp-lit one-eye scans read 1 cm small, true L). 35, not 30: on the lab
    // set a reflection that touches 30 during the roll (P12) read XL/XXL for a face today's width puts at L, and 35 kept
    // every other scan as it was; plain light agrees in 42-54. On the last rolling frame a steady today's width seen
    // earlier in this count stands in when the newest 60 frames are unsteady, so rolling never loses a steady result.
    // 'shadow' always shows today's width.
    function scanResult(lastTry) {
      const classic = classify(samples);
      if (classic.size) steadyToday = classic;
      const today = classic.size || !lastTry ? classic : steadyToday || classic;
      const iris = window.SpaceArmoryFitIris?.stable(irisFrames) || null;
      const usable = !!iris && iris.used >= 20;
      const bothEyes = usable && iris.agreeing >= 35;
      const live = root.dataset.irisMode === 'live' && usable && (bothEyes ? iris.stable || !lastTry : !lastTry || iris.stable && !today.size);
      const result = !live ? today : iris.stable && (bothEyes || lastTry) ? {size: window.SpaceArmoryFitRules?.sizeFor(iris.cm), metric: iris.cm} : {size: null};
      const part = (value, steady) => Number.isFinite(value) ? `${value.toFixed(2)} cm${steady ? '' : ' unsteady'}` : 'none';
      const compare = `iris ${usable ? part(iris.cm, iris.stable) + ` (${iris.agreeing}/60 both eyes${iris.oneEye ? ', one eye' : ''})` : 'none'} | today ${part(today.metric ?? median(samples), !!today.size)} | shown ${live ? 'iris' : 'today'}${glareShown ? ' | light hint' : ''}`;
      return {result, compare, split: root.dataset.irisMode === 'live' && usable && !bothEyes};
    }

    function finishScan() {
      if (finalizing || samples.length < targetSamples) return;
      const scored = scanResult(unsteadyFrames >= targetSamples);
      const result = scored.result;
      if (!result.size && unsteadyFrames < targetSamples) {
        unsteadyFrames += 1;
        // Rolling because the eyes do not agree shows the light hint even when the newest 20 frames are not under 40%.
        const glare = glareInEyes() || scored.split;
        if (glare) glareShown = true;
        announceStatus(glare ? 'glare' : 'hold');
        return;
      }
      finalizing = true;
      steadyToday = null;
      const running = attemptRunning;
      const stats = result.size ? completeAttempt() : null;
      stopMedia({preserveEngine: !!result.size});
      if (!result.size) {
        attemptRunning = running;
        showError('quality');
        return;
      }
      setStage('result');
      setScreen('result', '[data-result-heading]');
      privacyAnalytics('scan_complete');
      activeCompareText = scored.compare;
      const combined = averageWithRecentScans(result.metric);
      presentMeasurement(combined.count > 1 ? {size: window.SpaceArmoryFitRules.sizeFor(combined.cm), metric: combined.cm} : result, null, stats);
    }

    // Owner OK, 18 Oct (#4): rescans on this browser within an hour that stay within 1 cm of the earlier ones are one
    // face, so the result is their average (the last three) as one size. A scan further off is another face or a bad
    // earlier scan and starts a new run, as does "Measuring someone else?" on the guide's last step. Only fresh camera
    // scans take part. Since 19 Oct (owner) the result screen no longer says it is an average.
    const recentScansKey = 'sa_face_fit_recent_scans_v1';
    const recentScanWindowMs = 60 * 60 * 1000;
    const recentScanSpreadCm = 1;
    function recentScans() {
      try {
        const list = JSON.parse(localStorage.getItem(recentScansKey) || '[]');
        const now = Date.now();
        return Array.isArray(list) ? list.filter((scan) => Number.isFinite(scan?.cm) && Number.isFinite(scan?.at) && scan.at <= now && now - scan.at < recentScanWindowMs) : [];
      } catch (error) { return []; }
    }
    function keepRecentScans(list) {
      try { localStorage.setItem(recentScansKey, JSON.stringify(list.slice(-3))); } catch (error) {}
    }
    function averageWithRecentScans(cm) {
      const earlier = recentScans();
      const mean = earlier.length ? earlier.reduce((sum, scan) => sum + scan.cm, 0) / earlier.length : null;
      const run = (mean !== null && Math.abs(cm - mean) <= recentScanSpreadCm ? [...earlier, {cm, at: Date.now()}] : [{cm, at: Date.now()}]).slice(-3);
      keepRecentScans(run);
      return {cm: run.reduce((sum, scan) => sum + scan.cm, 0) / run.length, count: run.length};
    }

    function presentMeasurement(result, restoredRecord, scanStats) {
      activeSize = result.size;
      activeVariantId = null;
      // The size and both printed numbers come from the same rounded width (face-fit-rules.js display/text), so the
      // result never reads "14.0 cm" next to M or "5.49 in" next to L.
      const shown = window.SpaceArmoryFitRules.display(result.metric);
      activeMeasurementText = window.SpaceArmoryFitRules.text({cm: result.metric});
      // Only a fresh camera result can identify its measurement device. A restored
      // result keeps its original context, or stays unknown if it predates this field.
      activeMeasurementDevice = restoredRecord
        ? window.SpaceArmoryFitDevice?.normalize(restoredRecord.device)
        : window.SpaceArmoryFitDevice?.detect();
      activeMeasurementStats = window.SpaceArmoryFitRules?.normalizeScanStats?.(restoredRecord ? restoredRecord.scanStats : scanStats);
      savePendingMeasurement(activeMeasurementText);
      const record = restoredRecord || {schema: 1, cm: result.metric, method: 'camera', rules: sizeRuleVersion, engine: engineVersion, measuredAt: new Date().toISOString()};
      if (!restoredRecord && activeMeasurementDevice) record.device = activeMeasurementDevice;
      if (!restoredRecord && activeMeasurementStats) record.scanStats = activeMeasurementStats;
      activeRecord = record;
      root.dispatchEvent(new CustomEvent('space-armory:scan-complete', {bubbles: true, detail: {measurement: record, restored: !!restoredRecord}}));
      // Owner, 2026-10-23 (Gemini item 4): a fresh camera result is published to Shopify's customer events as
      // "face_fit_measured" (size only), for the custom pixel that builds the measured-but-not-bought audiences in Meta and
      // Google. A restored result (page reload, sign-in round trip, saved size) is not a new measurement and stays quiet.
      if (!restoredRecord) { try { window.Shopify?.analytics?.publish?.('face_fit_measured', {size: result.size, method: 'camera'}); } catch {} }
      recommended.textContent = root.dataset.resultSizeTemplate.replace('__SIZE__', result.size);
      recommended.hidden = false;
      applyButton.textContent = root.dataset.resultUseTemplate.replace('__SIZE__', result.size);
      addButton.textContent = decodeText(root.dataset.resultAddTemplate.replace('__SIZE__', result.size));
      // The width in the visitor's unit only (data-size-unit, snippets/sa-size-unit.liquid): "Measured Size: 5.67 in" on
      // the United States country, "Measured Size: 14.4 cm" elsewhere, the label the cart line uses (measuredSizeText).
      measurement.textContent = root.dataset.resultMeasurementTemplate
        .replace('__VALUE__', (root.dataset.sizeUnit === 'in' ? `${shown.inches} in` : `${shown.cm} cm`).replace(/(\d)\.(\d)/g, window.SA_I18N ? '$1,$2' : '$1.$2'));
      measurement.hidden = false;
      const match = findSizeControl(productInfo(), result.size);
      const canApply = !!match && !!variantForSize(productInfo(), result.size)?.available;
      manualOnly.hidden = canApply;
      manualOnly.textContent = canApply ? '' : root.dataset.resultUnavailable;
      applyButton.hidden = !canApply;
      // Set pages v2 apply the result to every mask (global.js setAll), so no mask is left without a size.
      const remainingSizes = root.dataset.bundleSizes === 'true' && !productInfo()?.faceFitPurchase?.setAll && productInfo()?.faceFitPurchase?.sizeIndices.some(index => index !== sizeOptionIndex() && !selectedOptionValues(productInfo())[index]);
      addButton.hidden = !canApply || remainingSizes;
      if (canApply && remainingSizes) { manualOnly.hidden = false; manualOnly.textContent = root.dataset.bundleRemainingSizes; }
      resultStatus.textContent = '';
      playResultMotion();
      triggerSuccessHaptic();
      resultHeading.focus({preventScroll: true});
    }

    listen(root, 'space-armory:clear-profile', () => {
      clearStoredMeasurement();
      activeMeasurementText = ''; activeSize = null; activeRecord = null; activeCompareText = '';
      activeMeasurementDevice = null;
      activeMeasurementStats = null;
      attemptSessions.delete(attemptSessionKey);
      attemptRunning = false;
      scanAttempts = {schema:1, attempts:0, retries:0, failed:0};
      try { sessionStorage.removeItem(attemptSessionKey); } catch {}
      removeLineItemProperty(measuredPropertyName);
      removeLineItemProperty(widthPropertyName);
      removeLineItemProperty(measurementPropertyName);
      removeLineItemProperty(scanSourcePropertyName);
      removeLineItemProperty(scanActionPropertyName);
      removeLineItemProperty(scanDevicePropertyName);
      removeLineItemProperty(comparePropertyName);
      attachMeasurementStats(productForm(), null);
    });

    listen(root, 'space-armory:restore-measurement', event => {
      const record = event.detail?.measurement;
      if (!window.SpaceArmoryFitRules?.valid(record)) return;
      activeCompareText = '';
      openDialog();
      setStage('result');
      setScreen('result', '[data-result-heading]');
      presentMeasurement({size: window.SpaceArmoryFitRules.sizeFor(record.cm), metric: record.cm}, record);
    });

    async function beginScan(options = {}) {
      if (sessionStarting) return;
      // Every way to the camera (Retry, the phone link opened on a tablet, a site link) ends at the QR code on a
      // computer or tablet.
      if (window.SpaceArmoryFitDevice?.measuresOnPhone?.()) { await showPhoneHandoff(); return; }
      finalizing = false;
      sessionStarting = true;
      stopMedia({preserveEngine: true});
      sessionStarting = true;
      startAttempt();
      const token = generation;
      samples = [];
      irisFrames = [];
      lastSampleAt = 0;
      unsteadyFrames = 0;
      glareShown = false;
      glareOn = false;
      steadyToday = null;
      lastFrameAt = 0;
      activeSize = null;
      activeVariantId = null;
      activeMeasurementText = '';
      activeMeasurementDevice = null;
      activeMeasurementStats = null;
      activeRecord = null;
      activeCompareText = '';
      successHapticPlayed = false;
      resetResultMotion();
      measurement.hidden = true;
      progress.value = 0;
      setStage('camera');
      setScreen('scan', '[data-screen="scan"] .face-fit__heading');
      scanStatus.textContent = root.dataset.statusStarting;
      opener.disabled = true;
      try {
        if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
          await showNoCamera();
          return;
        }
        const preparedEngine = prepareInferenceEngine();
        preparedEngine.catch(() => {});
        const newStream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: 'user', width: { ideal: 640 }, height: { ideal: 480 }, resizeMode: 'crop-and-scale' }, audio: false });
        if (token !== generation || !dialog.open) {
          newStream.getTracks().forEach((track) => track.stop());
          return;
        }
        stream = newStream;
        video.srcObject = stream;
        await video.play();
        const previewStartedAt = performance.now();
        if (!video.videoWidth) {
          await new Promise((resolve, reject) => {
            let timer;
            const finish = (error) => {
              if (timer) window.clearTimeout(timer);
              video.removeEventListener('loadedmetadata', onLoaded);
              cancelVideoMetadataWait = null;
              if (error) reject(error);
              else resolve();
            };
            const onLoaded = () => finish(null);
            timer = window.setTimeout(() => finish(new Error('video_timeout')), 8000);
            cancelVideoMetadataWait = finish;
            video.addEventListener('loadedmetadata', onLoaded, { once: true });
          });
        }
        await revealStablePreview(token, previewStartedAt);
        if (token !== generation || !dialog.open) return;
        setStage('align');
        scanStatus.textContent = root.dataset.statusPreparing;
        const currentEngine = await preparedEngine;
        if (token !== generation || !dialog.open || !currentEngine) return;
        if (inferenceMode === 'worker') worker.postMessage({type: 'reset', generation: token});
        const activeToken = generation;
        setStage('align');
        announceStatus('ready');
        launchFrameLoop(activeToken);
        sessionStarting = false;
        privacyAnalytics('stream_ready');
        stream.getVideoTracks().forEach((track) => track.addEventListener('ended', () => { if (activeToken === generation) showError('busy'); }, { once: true }));
        scanTimeout = window.setTimeout(() => {
          // A full count still rolling when time runs out gets its last try (a steady width seen in the count is shown);
          // only an unclear one ends on the quality error. Fewer frames than a count is a timeout.
          if (activeToken !== generation || !dialog.open || finalizing) return;
          if (samples.length >= targetSamples) { unsteadyFrames = targetSamples; finishScan(); }
          else showError('timeout');
        }, 60000);
      } catch (error) {
        if (token !== generation || !dialog.open) return;
        const name = error && error.name;
        if (options.fromHandoff && (name === 'NotAllowedError' || name === 'PermissionDeniedError')) showPhoneReady();
        else if (name === 'NotAllowedError' || name === 'PermissionDeniedError') showError('permission');
        else if (name === 'NotFoundError' || name === 'DevicesNotFoundError') await showNoCamera();
        else if (name === 'NotReadableError' || name === 'TrackStartError') showError('busy');
        else showError('model');
      } finally {
        opener.disabled = false;
        if (sessionStarting && !worker && !mainThreadLandmarker && !stream) sessionStarting = false;
      }
    }

    function eventAction(event) {
      const target = event.target instanceof Element ? event.target.closest('[data-face-fit-open], [data-close], [data-start], [data-phone-start], [data-copy-handoff], [data-guide-next], [data-guide-prev], [data-guide-forward], [data-guide-skip], [data-guide-dot], [data-someone-else], [data-stop], [data-retry], [data-manual], [data-apply], [data-add]') : null;
      if (!target || !root.contains(target)) return;
      if (target.matches('[data-guide-next], [data-guide-forward], [data-guide-prev], [data-guide-dot], [data-start], [data-guide-skip], [data-someone-else]') && !acceptGuideAction()) return;
      if (target.matches('[data-face-fit-open]')) {
        if (!productInfo()?.faceFitPurchase) openForMeasuring();
      }
      else if (target.matches('[data-close]') || target.matches('[data-stop]')) returnFocus();
      else if (target.matches('[data-guide-next], [data-guide-forward]')) setGuideStep(guideStep + 1);
      else if (target.matches('[data-guide-prev]')) setGuideStep(guideStep - 1);
      else if (target.matches('[data-guide-dot]')) setGuideStep(Number(target.dataset.guideDot));
      else if (target.matches('[data-copy-handoff]')) copyPhoneLink();
      else if (target.matches('[data-start], [data-guide-skip], [data-phone-start], [data-someone-else]') || target.matches('[data-retry]')) {
        cameraRequestedAt = performance.now();
        // Another person: this scan is not averaged with the earlier ones.
        if (target.matches('[data-someone-else]')) keepRecentScans([]);
        if (target.matches('[data-retry]')) {
          manualOnly.hidden = true;
          resultStatus.textContent = '';
        }
        beginScan();
      } else if (target.matches('[data-manual]')) {
        stopMedia({preserveEngine: true});
        // Error screen: Measure by Hand opens the string-and-ruler guide in place of the scanner.
        const guide = target.matches('[data-error-hand], [data-hand-guide]') ? handGuide() : null;
        if (typeof guide?.open === 'function') {
          returnFocus({focus: false});
          requestAnimationFrame(() => guide.open());
          return;
        }
        // The size row takes over, as for Add to Cart without a size: a tap scrolls to it and pulses it, the keyboard
        // lands on the chosen size or the row. Focusing the first size drew a ring around S beside the visitor's own size.
        const purchase = productInfo()?.faceFitPurchase;
        returnFocus({focus: !purchase});
        purchase?.focusSizes(true, event);
      } else if (target.matches('[data-apply]')) {
        if (variantActionBusy) return;
        variantActionBusy = true;
        applyButton.disabled = true;
        addButton.disabled = true;
        resultStatus.textContent = '';
        Promise.resolve().then(() => selectRecommendedSize()).then((selected) => {
          useMeasuredSizeProperty(selected.form, 'Only Apply Size');
          rememberAppliedMeasurement();
          resultStatus.textContent = root.dataset.resultApplied;
          privacyAnalytics('recommendation_apply');
          returnFocus();
        }).catch((error) => {
          resultStatus.textContent = error.message === 'variant_unavailable' ? root.dataset.resultUnavailable : root.dataset.resultApplyFailed;
        }).finally(() => { variantActionBusy = false; applyButton.disabled = false; addButton.disabled = false; });
      } else if (target.matches('[data-add]')) {
        addRecommendedToCart(target);
      }
    }

    async function addRecommendedToCart(button) {
      if (!activeSize || variantActionBusy) return;
      variantActionBusy = true;
      applyButton.disabled = true;
      addButton.disabled = true;
      try {
        const selected = selectRecommendedSize();
        const form = selected.form;
        if (!form || !activeVariantId) throw new Error('variant_missing');
        useMeasuredSizeProperty(form, 'Apply Size & Add to Cart');
        rememberAppliedMeasurement();
        await productInfo().faceFitPurchase.addToCart(null, () => returnFocus({focus: false}));
        resultStatus.textContent = root.dataset.resultAdded;
        privacyAnalytics('add_to_cart_success');
      } catch (error) {
        resultStatus.textContent = error.message === 'variant_unavailable' ? root.dataset.resultUnavailable : (error.message === 'variant_missing' ? root.dataset.resultApplyFailed : error.message || root.dataset.resultAddFailed);
        privacyAnalytics('add_to_cart_fail');
      } finally {
        variantActionBusy = false;
        applyButton.disabled = false;
        addButton.disabled = false;
      }
    }

    function preventMotionMenu(event) {
      if (event.target instanceof Element && event.target.closest('[data-motion-art]')) event.preventDefault();
    }

    listen(root, 'contextmenu', preventMotionMenu, true);
    listen(root, 'dragstart', preventMotionMenu, true);
    listen(root, 'click', eventAction);
    listen(root, 'space-armory:open-scanner', openForMeasuring);
    listen(root, 'space-armory:prepare-cart', () => prepareMeasurementForCart(productForm()));
    if (guide) {
      listen(guide, 'pointerdown', (event) => {
        if (!event.isPrimary || event.button !== 0 || root.dataset.activeScreen !== 'intro') return;
        if (event.target instanceof Element && event.target.closest('button')) return;
        guidePointer = { id: event.pointerId, x: event.clientX, y: event.clientY };
        try { guide.setPointerCapture(event.pointerId); } catch (error) {}
      });
      listen(guide, 'pointerup', (event) => {
        const start = guidePointer;
        guidePointer = null;
        if (!start || start.id !== event.pointerId || root.dataset.activeScreen !== 'intro') return;
        const dx = event.clientX - start.x;
        const dy = event.clientY - start.y;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.3) return;
        setGuideStep(guideStep + (dx < 0 ? 1 : -1));
      });
      listen(guide, 'pointercancel', () => { guidePointer = null; });
      listen(guide, 'lostpointercapture', () => { guidePointer = null; });
      listen(guide, 'keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        setGuideStep(guideStep + (event.key === 'ArrowRight' ? 1 : -1));
      });
    }
    listen(document, 'click', (event) => {
      const target = event.target instanceof Element ? event.target.closest('button[name="add"], button[type="submit"], input[type="submit"]') : null;
      const form = target && target.form;
      if (form && form === productForm()) prepareMeasurementForCart(form);
    }, true);
    listen(document, 'submit', (event) => {
      if (event.target === productForm()) prepareMeasurementForCart(event.target);
    }, true);
    attachPendingMeasurement(productForm());
    listen(dialog, 'cancel', () => stopMedia({preserveEngine: true}));
    listen(dialog, 'close', finishDialogClose);
    listen(video, 'ended', () => showError('busy'));
    listen(root, 'space-armory:scan-complete', () => { errorStreak = 0; permissionFailures = 0; });
    listen(window, 'pagehide', stopMedia);
    listen(document, 'visibilitychange', () => { if (document.visibilityState === 'hidden' && stream) showError('background'); });
    if (window.location.hash === '#face-fit-start') {
      // The QR link from a computer: the phone goes straight to the camera.
      // Consume once so refresh/back does not unexpectedly reopen the camera.
      history.replaceState(history.state, '', window.location.pathname + window.location.search);
      openDialog();
      beginScan({ fromHandoff: true });
    }
    // Site links to Measure My Face (footer, FAQ; owner 2026-10-17) end in #measure-my-face. They open it as tapping
    // its row on the page does: intro and privacy note first, no camera prompt on arrival. On a page that already has
    // a scanner the link stays on that mask instead of loading the default one.
    const measureLinkHash = '#measure-my-face';
    function openFromSiteLink() {
      root.querySelector('[data-face-fit-open]')?.click();
    }
    if (!window.SA_MEASURE_LINK_ROOT) {
      window.SA_MEASURE_LINK_ROOT = root;
      if (window.location.hash === measureLinkHash) {
        history.replaceState(history.state, '', window.location.pathname + window.location.search);
        if (document.readyState === 'loading') listen(document, 'DOMContentLoaded', () => window.setTimeout(openFromSiteLink, 0), {once: true});
        else window.setTimeout(openFromSiteLink, 0);
      }
      listen(document, 'click', (event) => {
        const link = event.target instanceof Element ? event.target.closest('a[href*="' + measureLinkHash + '"]') : null;
        if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        if (link.target && link.target !== '_self') return;
        event.preventDefault();
        if (dialog.open) return;
        openFromSiteLink();
      }, true);
    }
    root.disposeScanner = () => {
      lifecycle.abort();
      if (window.SA_MEASURE_LINK_ROOT === root) window.SA_MEASURE_LINK_ROOT = null;
      stopMedia();
      focusAfterClose = false;
      if (dialog.open) dialog.close();
      finishDialogClose();
      delete root.dataset.initialized;
    };
    root.dispatchEvent(new CustomEvent('space-armory:scanner-ready'));
    }
    const activeScanners = new Set();
    function mountScanners() {
      activeScanners.forEach(root => { if (!root.isConnected) { root.disposeScanner?.(); activeScanners.delete(root); } });
      document.querySelectorAll('face-fit-scanner').forEach(root => {
        if (!activeScanners.has(root)) { delete root.dataset.initialized; initializeScanner(root); }
        activeScanners.add(root);
      });
    }
    mountScanners();
    document.addEventListener('shopify:section:load', mountScanners);
    new MutationObserver(records => {
      if (records.some(record => [...record.addedNodes, ...record.removedNodes].some(node => node.nodeType === 1 && (node.matches('face-fit-scanner') || node.querySelector('face-fit-scanner'))))) mountScanners();
    }).observe(document.documentElement, {childList: true, subtree: true});
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["manual-size-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('manual-size-guide')) {
    customElements.define('manual-size-guide', class extends HTMLElement {
      connectedCallback() {
        if (this.lifecycle) return;
        this.dialog = this.querySelector('dialog');
        this.opener = this.querySelector('[data-manual-guide-open]');
        if (!this.dialog || !this.opener) return;
        this.lifecycle = new AbortController();
        const options = {signal: this.lifecycle.signal};
        const protectImage = event => {
          if (event.target instanceof Element && event.target.closest('.manual-size-guide__image')) event.preventDefault();
        };
        this.addEventListener('contextmenu', protectImage, options);
        this.addEventListener('dragstart', protectImage, options);
        this.opener.addEventListener('click', () => this.open(this.opener), options);
        this.querySelector('[data-manual-guide-close]').addEventListener('click', () => this.close(), options);
        this.dialog.addEventListener('close', () => this.afterClose(), options);
        this.querySelectorAll('[data-unit]').forEach(tab => {
          tab.addEventListener('click', () => this.selectUnit(tab.dataset.unit), options);
          tab.addEventListener('keydown', event => {
            if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
            event.preventDefault();
            const unit = event.key === 'Home' ? 'in' : event.key === 'End' ? 'cm' : tab.dataset.unit === 'in' ? 'cm' : 'in';
            this.selectUnit(unit);
            this.querySelector(`[data-unit="${unit}"]`).focus();
          }, options);
        });
      }

      selectUnit(unit) {
        if (unit !== 'in' && unit !== 'cm') return;
        this.querySelectorAll('[data-unit]').forEach(tab => {
          const selected = tab.dataset.unit === unit;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
          if (selected) this.querySelector('[data-unit-panel]').setAttribute('aria-labelledby', tab.id);
        });
        this.querySelectorAll('[data-in][data-cm]').forEach(cell => { cell.textContent = window.SA_I18N ? cell.dataset[unit].replace(/(\d)\.(\d)/g, '$1,$2') : cell.dataset[unit]; });
        const label = unit === 'in' ? 'inches' : 'centimeters';
        // French, Spanish and German pages: the same sentences from window.SA_I18N (snippets/sa-i18n-js.liquid).
        const i18n = window.SA_I18N;
        const shown = i18n?.[unit === 'in' ? 'size_guide.unit_inches' : 'size_guide.unit_cm'] ?? label;
        this.querySelector('table').setAttribute('aria-label', (i18n?.['size_guide.chart_label'] ?? 'Mask size chart in {unit}').replace('{unit}', shown));
        this.querySelector('[data-unit-heading]').textContent = (i18n?.['size_guide.measurement_in'] ?? 'Measurement in {unit}').replace('{unit}', shown);
      }

      open(trigger = this.opener) {
        if (this.dialog.open || this.closest('product-info')?.querySelector('face-fit-scanner dialog[open]')) return;
        this.returnFocus = trigger;
        this.previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        this.scrollLocked = true;
        this.dialog.showModal();
        this.dispatchEvent(new CustomEvent('space-armory:sizing-guide-opened', {bubbles: true, detail: {guide: 'manual'}}));
        this.querySelector('.manual-size-guide__content').scrollTop = 0;
        this.querySelector('[data-manual-guide-close]').focus({preventScroll: true});
        this.notifyVisibility();
      }

      close() {
        if (this.dialog.open) this.dialog.close();
        this.afterClose();
      }

      afterClose() {
        if (!this.scrollLocked || this.dialog.open) return;
        document.body.style.overflow = this.previousOverflow;
        this.scrollLocked = false;
        this.notifyVisibility();
        if (this.isConnected && this.returnFocus?.isConnected && !this.returnFocus.hidden) this.returnFocus.focus({preventScroll: true});
      }

      notifyVisibility() {
        this.dispatchEvent(new CustomEvent('space-armory:scanner-visibility', {bubbles: true}));
      }

      disconnectedCallback() {
        this.lifecycle?.abort();
        this.lifecycle = null;
        if (this.dialog?.open) this.dialog.close();
        this.afterClose();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
